'use client'

import React, { useCallback, useEffect, useState } from 'react'
import NextLink from 'next/link'
import NextImage from 'next/image'

import Button from '@/components/Button'
import {
	LeftArrowIcon,
	LinkIcon,
	MailIcon,
	RightArrowIcon,
	TelegramIcon,
	UpRightArrowIcon,
	VkIcon
} from '@/components/Icon'
import Typography from '@/components/Typography'

import styles from '../../styles.module.css'
import IconButton from '@/components/IconButton'
import useEmblaCarousel from 'embla-carousel-react'
import { EmblaCarouselType } from 'embla-carousel'
import ShareSection from '../ShareSection'
import Link from '@/components/Link'
import ImagesCarousel from '../ImagesCarousel'
import ArticleImages from '../ArticleImages'

const similarCases: any[] = [
	// {
	//   img: "/passport.jpeg",
	//   href: "#",
	//   badge: "Образование",
	//   title: "Внедрение искусственного интеллекта (AI)",
	//   description:
	//     "Сервис для создания сопроводительного письма в иммиграционную службу",
	// },
	// {
	//   img: "/vehicle.png",
	//   href: "#",
	//   badge: "Производство",
	//   title: "Цифровизация завода",
	//   description:
	//     "Крупнейший производитель вездеходов в Восточной Сибири и на Дальнем Востоке",
	// },
]

export default function Article3() {
	return (
		<>
			<article className={styles.article}>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Клиент
					</Typography>
					<Typography variant='p1'>
						Школа вкуса «Пряности & сладости» в Югорске. Направления деятельности компании: кулинарные
						мастер-классы и росписи кондитерских изделий для взрослых и детей, мастер-классы для женщин.
					</Typography>
				</section>
				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Задача
					</Typography>
					<Typography variant='p1'>
						Разработать уникальный фирменный стиль, который будет легко ассоциироваться с деятельностью компании.
						Фирменный стиль должен включать в себя разработку нейминга, логотипа, паттерна, айдентики.
						Предпочтительная палитра — тёплая, монохромная.
					</Typography>
				</section>

				<section className={styles.article__section}>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/3-1.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/3-2.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/3-3.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/3-4.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/3-5.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/3-6.png').default,
								placeholder: 'blur'
							}
						]}
					/>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Предпроектное исследование
					</Typography>
					<Typography variant='p1'>
						На данном этапе отдел маркетинга true.code провёл анализ рынка для определения ниши, конкурентов,
						ценовой политики и спроса. Также мы провели анализ целевой аудитории и определили её потребности и
						уникальные особенности.
					</Typography>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Нейминг
					</Typography>
					<Typography variant='p1'>
						Название компании должно соответствовать следующим критериям: уникальный, дружелюбный, привлекательный
						и быстро ассоциирующийся с деятельностью компании. Мы выбрали созвучный вариант из двух слов, которые
						при написании имеют схожую размерность. Название компании «Пряности и сладости» вызывает ассоциации с
						чем-то съедобным и ароматным, что в полной мере подходит компани проводящей кондитерские и кулинарные
						мастер-классы.
					</Typography>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Цветовая гамма
					</Typography>
					<Typography variant='p1'>
						Цветовая палитра подобрана таким образом, чтобы перекликаться с цветами «Югорского пряника», но больше
						приближена к изделиям из имбирного теста. Тёплый коричневый цвет в логотипе создает атмосферу уюта,
						традиций и натуральности.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/3-7-1.png').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Логотип
					</Typography>
					<Typography variant='p1'>
						Первой и главной ассоциацией, которая была во время дизайна были имбирные пряники. Поэтому мы взяли
						мягкую форму многогранной звезды, напоминающую пряник. Название компании имеет широкий рукописный
						шрифт, который создает дружелюбную атмосферу и указывает на ручную работу при изготовлении
						кондитерских изделий.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/3-8.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/3-9.png').default,
								placeholder: 'blur'
							}
						]}
					/>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Паттерн
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/3-10.png').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
				</section>

				<section className={styles.article__section}>
					<Typography variant='h2' className={styles.article__headline}>
						Айдентика
					</Typography>
					<Typography variant='p1'>
						Завершающим этапом стало применение фирменного стиля на различных носителях как в
						digital-пространстве, так и в виде физических носителей. Мы разработали пример оформления социальных
						сетей, рекламных креативов и постов и историй. Для физических носителей была разработана коллекция из
						дипломов, сертификатов, визиток и других бумажных носителей.
					</Typography>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/3-11.png').default,
								placeholder: 'blur'
							}
						]}
						scaleDown
					/>
				</section>

				<section className={styles.article__section}>
					<ArticleImages
						images={[
							{
								src: require('../../../../../../public/images/portfolio/3-13.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/3-14.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/3-15.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/3-16.png').default,
								placeholder: 'blur'
							},
							{
								src: require('../../../../../../public/images/portfolio/3-17.png').default,
								placeholder: 'blur'
							}
						]}
					/>
				</section>

				<ShareSection />
			</article>

			{similarCases.length > 0 && (
				<section className={`${styles.similar__projects}`}>
					<Typography variant='h2'>Похожие проекты</Typography>
					<div className={`${styles.cases__cards}`}>
						{similarCases.slice(0).map(({ img, href, badge, description, title }, idx) => (
							<div className={styles.case} key={idx}>
								<div className={styles.card}>
									<NextImage
										className={styles['card-image']}
										src={img}
										alt=''
										fill
										priority
										sizes='(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw'
									/>
									<div className={styles.badge}>{badge}</div>
									<div className={styles['card-hover']}>
										<div className={styles['card-hover__content']}>
											<span className={styles['card-hover__text-small']}>Ознакомиться с кейсом</span>
											{/* <span className={styles["card-hover__text-big"]}>x3</span>{" "}
                      <span className={styles["card-hover__text-small"]}>
                        Рост конверсии
                      </span>
                      <span className={styles["card-hover__text-big"]}>60</span>{" "}
                      <span className={styles["card-hover__text-small"]}>
                        Часов работы
                      </span> */}
											<IconButton
												Icon={UpRightArrowIcon}
												variant='circle'
												className={styles['card-hover__button']}
											/>
										</div>
									</div>
								</div>
								<Typography variant='h5' className={styles.case__headline}>
									{title}
								</Typography>
								<Typography variant='p2' color='description' className={styles.case__description}>
									{description}
								</Typography>
							</div>
						))}
					</div>
				</section>
			)}
		</>
	)
}
